import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import PersonForm from "../../components/Persons/PersonsForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";

const PersonsCreate = ({classes, personType, formUrl, preselectedHouse, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('persons.new_' + personType)}
        />

        <Paper>
            <CardContent>
                <PersonForm
                    personType={personType}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default PersonsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/persons/Create.jsx